import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ScrollTopService {
  private scrollTop$ = new Subject<void>();

  onRequest(): Observable<void> {
    return this.scrollTop$.asObservable();
  }

  request(): void {
    this.scrollTop$.next();
  }
}
